import BaseListPresenter from "../../../base/BaseListPresenter";
import buildDateQuery from "../../../buildDateQuery";

class DashboardPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    getCurrentUserUseCase,
    getObjectUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      deleteObjectUseCase,
      upsertUseCase,
      getCurrentUserUseCase,
      getObjectUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.getCurrentUserUseCase = getCurrentUserUseCase;
    this.getObjectUseCase = getObjectUseCase;
  }

  init() {
    const user = this.view.getCurrentUser();

    this.where = {
      client: { id: user.client?.id },
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }
}

export default DashboardPresenter;
